/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentPackPublicStatus =
    (typeof DocumentPackPublicStatus)[keyof typeof DocumentPackPublicStatus];

export const DocumentPackPublicStatus = {
    NotStarted: 'notStarted',
    InProgress: 'inProgress',
    Complete: 'complete',
} as const;
